module.exports = __webpack_public_path__ + "static/media/clip.60fdbb5b.svg";